export const environment = {
  apiBaseUrl: 'https://eetdag-api.kissit.be/api',
  production: true
};



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/environments/environment.ts